import { useEffect, useState } from "react";
import "./Splashscreen.css";

/**
 * Props:
 *  blocking  — no timer, just sits there. Parent unmounts it when ready.
 *  autoExit  — runs its own 2.2s timer then calls onDone() after fade.
 *  onDone    — called after fade-out completes (autoExit mode only).
 */
const SplashScreen = ({ blocking = false, autoExit = false, onDone }) => {
  const [phase, setPhase] = useState("enter");

  useEffect(() => {
    if (autoExit) {
      const t = setTimeout(() => setPhase("exit"), 300); // short delay then fade
      return () => clearTimeout(t);
    }
  }, [autoExit]);

  const handleTransitionEnd = (e) => {
    if (phase === "exit" && e.propertyName === "opacity") {
      onDone?.();
    }
  };

  return (
    <div
      className={`splash ${phase === "exit" ? "splash--exit" : ""}`}
      onTransitionEnd={handleTransitionEnd}
    >
      <div className="splash__body">
        <div className="splash__wordmark">
          <span className="splash__word splash__word--jey">JEYSHAWN</span>
          <span className="splash__word splash__word--eng">ENGINEERING LIMITED</span>
        </div>
        <p className="splash__tagline">
          Integrated Energy Services &nbsp;·&nbsp; Excellence &nbsp;·&nbsp; Integrity
        </p>
      </div>

      <div className="splash__bar-wrap">
        {/* In blocking mode the bar pulses; in autoExit it fills then we fade */}
        <div className={`splash__bar ${blocking ? "splash__bar--pulse" : "splash__bar--fill"}`} />
      </div>
    </div>
  );
};

export default SplashScreen;